import React from 'react';
import { Table, Link } from '@b-design/fusion';
import ColorTags from '@/components/ColorTags';
import $i18n from '../../../../../i18n';
import { history } from 'ice';
import { formatTime } from '@/utils';
import { getAppVersionStatus } from '@/utils/status';
import { getQueryStringArgs } from '@/utils/url-parse';
import './index.less';

interface Props {
  dataSource: any[];
  subLoading: boolean;
}

const SubVersionTable: React.FC<Props> = ({ dataSource, subLoading }) => {
  const { appId, spaceId } = getQueryStringArgs();

  const renderPublish = (value, index, record) => {
    return (
      <div className="sub-version-table-publish-div">
        <img src={value} className="img-sub-publish" alt="" />
        <div className="publish-div-value">{record.channelName}</div>
      </div>
    );
  };

  const actions = (value, index, record) => {
    return (
      <div className="actions-content">
        <Link
          style={{
            padding: '0 5px',
            fontSize: '12px',
            color: 'var(--superapp-primary-1)',
            letterSpacing: '0.4px',
            lineHeight: '20px',
          }}
          onClick={() =>
            history?.push(
              `/miniapp/version?spaceId=${spaceId || ''}&appId=${appId}&channelCode=${record.channelCode}&version=${record.version}`,
            )
          }
        >
          <span className="superapp_iconfont superapp_icon-yanjing" />
          {$i18n.get({ id: 'aopf.pages.miniapp.table.Action.Detail', dm: '详情' })}
        </Link>
      </div>
    );
  };

  return (
    <>
      <Table dataSource={dataSource} hasBorder={false} loading={subLoading}>
        <Table.Column width={90} />
        <Table.Column
          title={$i18n.get({
            id: 'aopf.pages.miniapp.versions.table.subTable.Published.App',
            dm: '目标渠道',
          })}
          dataIndex="channelIcon"
          cell={renderPublish}
          width={220}
        />
        <Table.Column
          title={$i18n.get({
            id: 'aopf.pages.miniapp.versions.table.subTable.Status',
            dm: '状态',
          })}
          dataIndex="versionStatus"
          cell={(value) => {
            const status = getAppVersionStatus(value);
            return <ColorTags tagTheme={status?.tagTheme} name={status?.name} />;
          }}
          width={200}
        />
        <Table.Column
          title={$i18n.get({
            id: 'aopf.pages.miniapp.versions.table.subTable.Created.On',
            dm: '创建时间',
          })}
          dataIndex="gmtCreate"
          cell={(value) => {
            return formatTime(value);
          }}
          width={180}
        />
        <Table.Column
          title={$i18n.get({
            id: 'aopf.pages.miniapp.versions.table.subTable.Released.On',
            dm: '发布时间',
          })}
          dataIndex="gmtModified"
          cell={(value) => {
            return formatTime(value);
          }}
          width={180}
        />
        <Table.Column title="" cell={actions} width={100}/>
      </Table>
    </>
  );
};

export default SubVersionTable;
